import React from 'react';
import { MonitoringStore } from '../../stores/MonitoringStore';
import { TemplatesStore } from '../../stores/TemplatesStore';
import { BILoggerStore } from '../../stores/BILoggerStore';
import { injectStoresV2 } from '../../stores/injectStoresV2';
import { Template } from './Template/Template';
import s from './Templates.scss';

interface TemplatesProps {
  monitoringStore: MonitoringStore;
  templatesStore: TemplatesStore;
  biLoggerStore: BILoggerStore;
  dataHook?: string;
}

const TemplatesCmp: React.FC<TemplatesProps> = ({ templatesStore, dataHook, biLoggerStore, monitoringStore }) => {
  const { items, responseUuid, bestMatchItemIds } = templatesStore;

  React.useEffect(() => {
    monitoringStore.stopActiveInteraction();
    biLoggerStore.logPageFullyRendered(biLoggerStore.getLastInteractionKey());
    biLoggerStore.logTemplatesLoaded();
  }, [monitoringStore, responseUuid, biLoggerStore]);

  return (
    <ul className={s.templates} data-hook={dataHook}>
      {items.map((template, index) => (
        <Template
          key={template.id}
          template={template}
          galleryDocIndex={index}
          hasMatchBadge={bestMatchItemIds.includes(template.id)}
        />
      ))}
    </ul>
  );
};

export const Templates = injectStoresV2('templatesStore', 'biLoggerStore', 'monitoringStore')(TemplatesCmp);
